import { useEffect, useRef } from 'react';
import { previewQuotePdf, exportQuotePdf } from '../quotePdfExport';
import { previewInternalQuotePdf, printInternalQuotePdf } from '../quoteInternalPdfExport';
import { assertQuoteDocumentReady } from '../quoteDocumentReadiness';
import { previewCompositionPdf } from '../quote.api';

export default function useQuoteDocumentExport({ context, setError }) {
  const latest = useRef(context.editor);
  latest.current = context.editor;
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const run = async (exporter, documentType) => {
    const submitted = context.editor;
    try {
      assertQuoteDocumentReady({ ...context, documentType });
      setError(null);
      await exporter(context, documentType);
      return true;
    } catch (error) {
      if (mounted.current && latest.current === submitted) setError(error.message || 'Impossible de produire le document.');
      return false;
    }
  };
  const pdfV2 = async documentType => {
    let target;
    try {
      assertQuoteDocumentReady({ ...context, documentType }); setError(null);
      target = window.open('', '_blank'); if (!target) throw new Error('Autorisez l’ouverture du PDF.'); target.opener = null;
      const blob = await previewCompositionPdf(context.editor.id, context.editor.quoteVersionId, documentType);
      const url = URL.createObjectURL(blob); target.location.href = url;
      window.setTimeout(() => URL.revokeObjectURL(url), 60000); return true;
    } catch (error) { target?.close(); setError(error.message); return false; }
  };
  const v2 = context.editor?.contentSchemaVersion === 2;
  return {
    previewPrintTemplate: () => run(previewQuotePdf),
    printPdf: () => run(exportQuotePdf),
    previewInternalTemplate: (type) => v2 ? pdfV2(type) : run(previewInternalQuotePdf, type),
    printInternalTemplate: (type) => v2 ? pdfV2(type) : run(printInternalQuotePdf, type),
  };
}
